export function calculateSearchedDataKeys(initialRowKeys, searchQuery, searchIndex) {

    let searchedDataKeys;

    // we take the original search index and cull it down to the items we are currently filtering for
    // Note: we create a new search index here so as to not mutate the original.
    const filteredSearchIndex = Object.assign({}, ...initialRowKeys.map(rowKey => ({[rowKey]: searchIndex[rowKey]})));

    if ( searchQuery === '' ) {
        // if there is no search query then we use initial state
        // Note: we return a copy of the initial state so as to not mutate the original data
        searchedDataKeys = [ ...initialRowKeys ];

    } else {

        try {
            const reg = new RegExp(searchQuery, 'i');
            searchedDataKeys = initialRowKeys.filter(rowKey => reg.test(filteredSearchIndex[rowKey]))

        } catch(e) {
            searchedDataKeys = []  // when regex matches error we want to return no results to simulate a simple no matches result
        }
    }

    return searchedDataKeys
}
